import { useState, useEffect, useRef, useCallback } from 'react'; // Importar useState, useEffect, useRef
import { Link } from 'react-router-dom';
import { FaPhoneAlt } from 'react-icons/fa'; // Icono de teléfono
import './Header.css';
import { FaWhatsapp, FaInstagram } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import logoB from '../images/logob-600.webp';



export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false); // Estado para el menú
  const [isSubmenuOpen, setIsSubmenuOpen] = useState(false); // Estado para el submenú
  const menuRef = useRef(null); // Referencia para el menú
  const toggleButtonRef = useRef(null); // Referencia para el botón de menú


    const navigate = useNavigate();
    const handleClickBTN = (event) => {
      event.preventDefault();
      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      if (isMobile) {
        window.location.href = 'tel:+56983221037'; // Reemplaza con tu número de teléfono
      } else {
        navigate('/Contacto'); // Reemplaza con la URL de tu página de contacto
      }
      closeMenu();
    };


  // Función para alternar el estado del menú lateral
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Función para alternar el estado del submenú en móvil
  const toggleSubmenu = () => {
    setIsSubmenuOpen(!isSubmenuOpen);
  };

  // Función para cerrar el menú al seleccionar un enlace
  const closeMenu = () => {
    setIsMenuOpen(false);
    setIsSubmenuOpen(false);
  };

  // Detectar clics fuera del menú solo en pantallas móviles
  const handleClickOutside = useCallback((event) => {
    if (isMenuOpen && window.innerWidth <= 768) { // Solo aplica en pantallas móviles
      if (
        menuRef.current && !menuRef.current.contains(event.target) && // Detecta si el clic es fuera del menú
        toggleButtonRef.current && !toggleButtonRef.current.contains(event.target) // Detecta si el clic no es en el botón del menú
      ) {
        setIsMenuOpen(false); // Cerrar el menú si se hace clic fuera de él
      }
    }
  }, [isMenuOpen]);

  // Agregar y remover el event listener
  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [handleClickOutside]);

  return (
    <header>
       {/* Nueva barra superior */}
       <div className="top-bar">
        <p className=' italic  '>
        "Calidez humana que marca la diferencia"
        </p>
       
      </div>
   <div className="header-container">
   <Link to="/" className="logo flex mr-auto" aria-label="Ir al inicio de Funeraria Coquimbo">
    <img 
      src={logoB}
      alt="Funeraria Coquimbo"
      width="600"
      height="338"
      className="logo-img site-logo-header md:ml-12 mb-4 transition-transform duration-300 ease-in-out hover:scale-105"
      decoding="async"
    />
  </Link>

        {/* Menú principal */}
        <nav id="primary-navigation" ref={menuRef} aria-label="Navegación principal" className={`nav-links ${isMenuOpen ? 'open' : ''}`}>
          <Link to="/" onClick={closeMenu}>Inicio</Link>

          {/* Dropdown para Planes de Servicios */}
          <div className="dropdown">
            <button
              type="button"
              className="dropdown-toggle"
              onClick={toggleSubmenu}
              aria-expanded={isSubmenuOpen}
              aria-controls="services-submenu"
            >
              Planes de Servicios
            </button>
            <div id="services-submenu" className={`dropdown-content ${isSubmenuOpen ? 'open' : ''}`}>
              <Link to="/PlanesDeServicio/eco" onClick={closeMenu}>Plan Eco</Link>
              <Link to="/PlanesDeServicio/estandar" onClick={closeMenu}>Plan Estándar Tradicional</Link>
              <Link to="/PlanesDeServicio/silver" onClick={closeMenu}>Plan Silver</Link>
              <Link to="/PlanesDeServicio/black" onClick={closeMenu}>Plan Black</Link>
              <Link to="/PlanesDeServicio/golden" onClick={closeMenu}>Plan Golden</Link>
            </div>
          </div>

          <Link to="/QuienesSomos" onClick={closeMenu}>Quienes somos</Link>
          <Link to="/Contacto" onClick={closeMenu}>Contacto</Link>
          <Link to="/Contacto" className="cta-button" onClick={handleClickBTN}>
      <FaPhoneAlt /> Llámanos Ahora
    </Link>

          {/* Sección inferior para frase o íconos */}
          {isMenuOpen && (
            <div className="menu-footer mt-auto mb-4 text-center text-gray-400">
              <div className="flex flex-col items-center justify-center ">
  <img
    src={logoB}
    alt="Funeraria Coquimbo"
    width="600"
    height="338"
    className="site-logo-menu mb-4"
    decoding="async"
  />
  </div>
              
              <p className="text-sm italic">"Calidez humana que marca la diferencia"</p>
              <div className="flex justify-center mt-2 space-x-6">
                <a href="https://www.instagram.com/funerariacoquimbo/" className="flex items-center justify-center" aria-label="Instagram de Funeraria Coquimbo">
                  <FaInstagram className="text-2xl" />
                </a>
                <a href="https://wa.me/+56983221037" className="flex items-center justify-center" aria-label="Escríbenos por WhatsApp">
                  <FaWhatsapp className="text-2xl" />
                </a>
              </div>
            </div>
          )}
        </nav>

        {/* Toggle del menú (versión móvil) */}
        <button
          type="button"
          ref={toggleButtonRef}
          className="menu-toggle"
          aria-label="Abrir menú principal"
          aria-expanded={isMenuOpen}
          aria-controls="primary-navigation"
          onClick={toggleMenu}
        >
          &#9776;
        </button>
      </div>
    </header>
  );
}
